<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Tên khóa</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input  [(ngModel)]="itemChungChi.courseName"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập tên khóa" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="namNhapHoc" nzRequired>Ngày đào tạo</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback  >
            <nz-date-picker [nzFormat]="'dd/MM/yyyy'" [(ngModel)]="itemChungChi.courseDate" [ngModelOptions]="{standalone: true}"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS"  >Thời gian đào tạo</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="itemChungChi.timeStudy"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập thời gian đào tạo">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Cơ sở đào tạo</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="itemChungChi.placeOfStudy"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập cơ sở...">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24"> 
          <nz-form-item>
            <nz-form-label nzSpan="24">Loại chứng nhận</nz-form-label>
            <asc-autocomplete [ascModel]="TypeOfCertificationsControl" (ascModelChange)="changeTypeOfCertifications($event)"
              [placeholder]="'Chọn loại chứng nhận'" [getListAC]="getTypeOfCertificationsACFn"></asc-autocomplete>
          </nz-form-item> 
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS">Ghi chú</nz-form-label>
          
            <input nz-input [(ngModel)]="itemChungChi.note"
            [ngModelOptions]="{standalone: true}"   type="text" placeholder="Nhập ghi chú...">
         
        </nz-form-item >
      </div>


     
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>